var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { computed, observable } from 'mobx';
import { sortBy } from 'lodash';
import API, { handleAsyncErrors } from '../utils/api';
var LabelsStore = /** @class */ (function () {
    function LabelsStore(floorPlanStore) {
        // --------------------------------------------------------------------------
        this.labelColors = ['blue', 'red', 'yellow', 'green', 'purple', 'pink', 'orange', 'peach', 'grey', 'white'];
        this.floorPlanStore = floorPlanStore;
    }
    Object.defineProperty(LabelsStore.prototype, "labels", {
        get: function () {
            var _a = this.floorPlanStore, assignedOwners = _a.assignedOwners, companyName = _a.companyName;
            return sortBy(assignedOwners.map(function (owner) { return ({
                ownerKey: owner.key,
                name: owner.name,
                floor: owner.floor ? owner.floor.title : '-',
                space: owner.space ? owner.space.title : '-',
                table: owner.table ? owner.table.letter : '-',
                color: owner.floor ? owner.floor.labelColor : '-',
                count: owner.stickersNumber,
                roomNumber: ((owner.space ? owner.space.title : '') + " " + (owner.table ? owner.table.letter : '')).trim(),
                companyName: companyName,
            }); }), ['roomNumber', 'name']);
        },
        enumerable: true,
        configurable: true
    });
    // --------------------------------------------------------------------------
    // Adapted from https://stackoverflow.com/a/53230807
    LabelsStore.prototype.downloadLabelsCsvFile = function (moveId) {
        return __awaiter(this, void 0, void 0, function () {
            var response, filename, url, link;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, API.fetchCSVExports(moveId)];
                    case 1:
                        response = _a.sent();
                        filename = this.floorPlanStore.move.path + "-label-order.csv";
                        url = window.URL.createObjectURL(new Blob([response.data]));
                        link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', filename);
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        return [2 /*return*/];
                }
            });
        });
    };
    __decorate([
        observable
    ], LabelsStore.prototype, "labelColors", void 0);
    __decorate([
        computed
    ], LabelsStore.prototype, "labels", null);
    __decorate([
        handleAsyncErrors({ logErrorMessage: 'Error in downloading the CSV file' })
    ], LabelsStore.prototype, "downloadLabelsCsvFile", null);
    return LabelsStore;
}());
export { LabelsStore };
//# sourceMappingURL=labels.js.map